import { render, staticRenderFns } from "./KasbonInstaller.vue?vue&type=template&id=94ef086a"
import script from "./KasbonInstaller.vue?vue&type=script&lang=js"
export * from "./KasbonInstaller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports